module.exports = __webpack_public_path__ + "img/image6.beb73057.png";